/**
 * DATI DELL'AZIENDA — chi è questa società.
 *
 * Una delle due metà in cui si è divisa la scheda azienda il 23-09-2026: identità, fiscale,
 * internazionale, marchio, attributi. Si compila una volta e cambia per fatti societari — è la
 * domanda del commercialista, non quella del capo del personale (l'altra metà è
 * `/organization/work-rules`).
 *
 * ⚠️ **Non c'è nessun selettore d'azienda**, ed è il punto della riorganizzazione: la pagina
 * parla dell'azienda in cui si è entrati, che la testata scrive sempre. `?company=` esiste per
 * il solo caso dichiarato — arrivare qui da «Holding», su un'azienda del proprio ramo — e in
 * quel caso la scheda lo dice: si sta amministrando dall'esterno.
 */
import { createFileRoute } from '@tanstack/react-router';
import { CompanyCard } from '@/features/tenants/CompanyCard';
import { COMPANY_DATA_SECTIONS } from '@/features/tenants/companySections';
import { parseCompanySearch } from '@/features/tenants/companySearch';

export const Route = createFileRoute('/_app/organization/company-data')({
  validateSearch: parseCompanySearch,
  component: CompanyDataPage,
});

function CompanyDataPage() {
  return <CompanyCard sections={COMPANY_DATA_SECTIONS} to="/organization/company-data" />;
}
